// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-fluid {
  padding: 20px;
}

h2 {
  margin-bottom: 20px;
  color: #333;
}

.mat-card {
  margin-bottom: 20px;
}

.mat-card-title {
  font-size: 18px;
  font-weight: 500;
}

.mat-card-header, ::ng-deep .mat-card-header {
  background-color: white !important;
  color: #333 !important;
  padding: 10px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

::ng-deep .mat-card-header-text {
  margin: 0 !important;
}

.form-group {
  margin-bottom: 15px;
}

.w-100 {
  width: 100%;
}

.filter-container {
  margin-bottom: 15px;
}

.table-container {
  position: relative;
  max-height: 400px;
  overflow: auto;
}

.table-container {
  tr.mat-mdc-row,
  tr.mat-mdc-header-row {
    height: 36px; /* default is 52px */
  }

  td.mat-mdc-cell,
  th.mat-mdc-header-cell {
    padding: 0 8px;
  }
}

table {
  width: 100%;
}

.mat-column-actions {
  width: 120px;
  text-align: center;
}

.mat-column-id {
  width: 80px;
}

.d-flex {
  display: flex;
}

.justify-content-between {
  justify-content: space-between;
}

.mt-3 {
  margin-top: 1rem;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.col-md-4 {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  flex: 0 0 33.333333%;
  max-width: 33.333333%;
}

.col-md-8 {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  flex: 0 0 66.666667%;
  max-width: 66.666667%;
}

@media (max-width: 768px) {
  .col-md-4, .col-md-8 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/client-group-management/client-group-management.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,aAAa;EACb,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;;IAEE,YAAY,EAAE,oBAAoB;EACpC;;EAEA;;IAEE,cAAc;EAChB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE;IACE,cAAc;IACd,eAAe;EACjB;AACF","sourcesContent":[".container-fluid {\n  padding: 20px;\n}\n\nh2 {\n  margin-bottom: 20px;\n  color: #333;\n}\n\n.mat-card {\n  margin-bottom: 20px;\n}\n\n.mat-card-title {\n  font-size: 18px;\n  font-weight: 500;\n}\n\n.mat-card-header, ::ng-deep .mat-card-header {\n  background-color: white !important;\n  color: #333 !important;\n  padding: 10px;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n\n::ng-deep .mat-card-header-text {\n  margin: 0 !important;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.w-100 {\n  width: 100%;\n}\n\n.filter-container {\n  margin-bottom: 15px;\n}\n\n.table-container {\n  position: relative;\n  max-height: 400px;\n  overflow: auto;\n}\n\n.table-container {\n  tr.mat-mdc-row,\n  tr.mat-mdc-header-row {\n    height: 36px; /* default is 52px */\n  }\n\n  td.mat-mdc-cell,\n  th.mat-mdc-header-cell {\n    padding: 0 8px;\n  }\n}\n\ntable {\n  width: 100%;\n}\n\n.mat-column-actions {\n  width: 120px;\n  text-align: center;\n}\n\n.mat-column-id {\n  width: 80px;\n}\n\n.d-flex {\n  display: flex;\n}\n\n.justify-content-between {\n  justify-content: space-between;\n}\n\n.mt-3 {\n  margin-top: 1rem;\n}\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n\n.col-md-4 {\n  position: relative;\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  flex: 0 0 33.333333%;\n  max-width: 33.333333%;\n}\n\n.col-md-8 {\n  position: relative;\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  flex: 0 0 66.666667%;\n  max-width: 66.666667%;\n}\n\n@media (max-width: 768px) {\n  .col-md-4, .col-md-8 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
